import { render, staticRenderFns } from "./scheme.vue?vue&type=template&id=ca7317e8&"
import script from "./scheme.vue?vue&type=script&lang=js&"
export * from "./scheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports